<template>
  <button
    class="mt-btn"
    :class="[variantClass, sizeClass]"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script setup>
defineEmits(['click']);

const props = defineProps({
  variant: {
    type: String,
    default: "primary", // primary, secondary, outline, orange, purple, muted, danger
  },
  size: {
    type: String,
    default: "md", // sm, md, lg
  },
  disabled: Boolean,
});

const variantClass = {
  primary: "mt-btn-primary",
  secondary: "mt-btn-secondary",
  outline: "mt-btn-outline",
  orange: "mt-btn-orange",
  purple: "mt-btn-purple",
  muted: "mt-btn-muted",
  danger: "mt-btn-danger",
}[props.variant];

const sizeClass = {
  sm: "px-3 py-1 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-6 py-3 text-lg",
}[props.size];
</script>
